<template>
  <b-overlay :show="loading">
    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
            <!-- TBD error component. -->
          </b-alert>

          <div v-if="!loading && !error">
            <h1 class="headline">
                To proceed to your CE exam, please complete this {{numQuestions}}-question survey.
                By doing so, you're helping to keep Viva Learning FREE.
                Thank you for your participation!
            </h1>

            <b-overlay :show="busy">
              <div class="div-survey-wrapper pl-2 pr-2 pt-3 pb-4">
                <div v-for="(row,ix) in survey.questions" v-bind:key="row.hash">
                  <div v-if="ix == curQuestionIx">
                    <b-col cols="12" class="div-survey-question">
                      {{row.question}}
                      &nbsp;
                      <span>{{getQuestionAddlText(row.type)}}</span>
                    </b-col>
                    <div class="mt-2">
                      <b-col cols="12" v-for="(row2,iy) in row.buttons" v-bind:key="row2.hash">
                          <b-button :class="[choiceClassArr,{'btn-survey-unchecked': !isPicked(iy)},{'btn-survey-checked': isPicked(iy)}]" block @click.prevent="pick(iy)">
                            <b-icon v-if="!isPicked(iy)" icon="square"></b-icon>
                            <b-icon v-if="isPicked(iy)" icon="x-square"></b-icon>
                            &nbsp;
                            {{row2.label}}
                          </b-button>
                      </b-col>
                      <!-- <b-col cols="12">
                        <b-card @click.prevent="submit(ix)">{{row.submit.label+' '+ix}}</b-card>
                      </b-col> -->
                      <b-col cols="12">
                        <b-button :disabled="submitDisabled" class="pt-2 pb-2" block variant="primary" @click.prevent="submit(ix)">
                          {{row.submit.label}}
                        </b-button>
                      </b-col>
                    </div>
                  </div>
                </div> <!-- v-for -->
                <b-col class="div-survey-footer pt-2">
                  Question {{curQuestionIx+1}}/{{numQuestions}}
                </b-col>
              </div>
            </b-overlay>

          </div>
        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service"
import utils from "@/utils/utils"

export default {
  name: 'Survey',
  data () {
    return {
      debug: false,
      loading: true,
      busy: false,
      error: false,
      errorMsg: 'System error.  Contact technical support.',
      msg: 'Survey',
      classHash: null,
      studentHash: this.$root.getToken(),
      survey: null,
      curQuestionIx: 0,
      choices: [],
      choiceClassArr: ["text-left","pl-3","pt-3","pb-3"]
    }
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      default: ""
    }
  },
  computed: {
    numQuestions() {
      return (this.survey) ? this.survey.questions.length : 0
    },
    questionType() {
      // returns multi, single, yesno
      return this.survey.questions[this.curQuestionIx].type
    },
    submitDisabled() {
      let aout = this.choices.every(item => !item)
      if (this.debug) console.log(`submitDisabled ${aout}`)
      return aout
    }
  },
  // watch: {
  //   choices: {
  //     // This will let Vue know to look inside the array
  //     deep: true,

  //     // We have to move our method to a handler field
  //     handler() {
  //       console.log('Choices changed!')
  //     }
  //   }
  // },
  methods: {
    getQuestionAddlText(questionType) {
        var aout
        switch (questionType.toLowerCase()) {
            case 'yesno':
                aout = ''
                break
            case 'single':
                aout = ' (select one)'
                break
            case 'multi':
                aout = ' (select all that apply)'
                break
            default:
                aout = ''
        }
        return aout
    },
    initChoices() {
      this.choices = []
      for (let ix = 0; ix < this.survey.questions[this.curQuestionIx].buttons.length; ix++) {
        // vue traps push to enforce reactivity
        this.choices.push(false)
      }
    },
    isPicked(buttonIx) {
      // console.log(`ixPicked: ${buttonIx}`)
      return this.choices[buttonIx]
    },
    pick(buttonIx) {
      // console.log(`buttonIx ${buttonIx}`)
      // https://stackoverflow.com/questions/41580617/vuejs-v-if-arrayindex-is-not-working
      // https://www.telerik.com/blogs/so-what-actually-is-vue-set
      // triggers reactivity
      this.$set(this.choices, buttonIx, !this.choices[buttonIx])

      let qtype = this.questionType   // returns yesno, single and multi
      if (qtype == 'yesno' || qtype == 'single') {
        // reset all other items to be inverse of changed item
        for (let ix=0; ix < this.choices.length; ix++) {
          if (ix != buttonIx) {
            // use reactive $set
            this.$set(this.choices, ix, !this.choices[buttonIx])
          }
        }
      }
      if (this.debug) console.log(`choice(${buttonIx}) ${this.choices[buttonIx]}`)
    },
    submit(questionIx) {
      if (this.busy) return   // bail out if still awaiting response.
      this.busy = true
      let choiceHash = []   // array of chosen option hashes
      for (let ix=0; ix<this.choices.length; ix++) {
        if (this.choices[ix]) {
          choiceHash.push(this.survey.questions[questionIx].buttons[ix].hash)
        }
      }

      // The server can send an email on laxt question.
      let isLast = (questionIx == (this.numQuestions-1))

      let data = {
        s: this.studentHash,
        sh: this.survey.hash,
        q: this.survey.questions[questionIx].hash,
        choices: choiceHash,
        sessionHash: this.survey.sessionHash,
        isLast: isLast
      }

      service
        .saveSurveyResponse(data)
        .then(
          (res => {
            // console.log(`back from saveSurveyResponse`)
            if (this.debug) console.log(res)
            if (res.status) {

              // If last question, else proceed to exam,
              if ((questionIx+1) < this.numQuestions) {
                this.curQuestionIx = questionIx + 1
                this.initChoices()
                if (this.debug) console.log(`Button ${ix}  cix ${this.curQuestionIx}`)
              }
              else {
                // Move on to exam.
                this.$router.push(`/exam/${this.classHash}`)
              }
            }
            else {
              // status returns false when student did not reserve seat
              this.error = true
              this.errorMsg = 'Error recording response. Try again later.'
            }
          }).bind(this)
        )
        .finally(e => {
          this.busy = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System error recording response. Try again later.'
          console.log(e);
        })
    }
  },
  created() {
    this.classHash = this.c || this.$route.query.c || null
    service
      .getSurvey(this.classHash, this.studentHash)
      .then(
        ( res => {
          if (this.debug) console.log(`back from getSurvey`)
          if (this.debug) console.log(res)
          if (res.status && res.rowCount !== 0) {
            if (this.debug) console.log(res)
            this.survey = res.data[0]
            this.curQuestionIx = 0
            this.initChoices()
          }
          else { // no survey to show, proceed to exam
            this.$router.push({ path: `/exam/${this.classHash}` })
          }
        }).bind(this)
      )
      .finally(e => {
        this.loading = false
        if (this.debug) console.log(`finally... getSurvey`);
      })
      .catch(e => {
        this.error = true
        this.errorMsg = "Error accessing API."
        console.log(e)
      })
  },
  mounted() {

  },
  beforeDestroy() {
    this.loading = true
    this.survey = null
    this.curQuestionIx = 0
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.headline {
  font-size: 1rem;
  line-height: 150%;
}
.div-survey-wrapper {
  background-color: black;
  color: white;
}
.div-survey-question {
  font-size: 1.1rem;
  line-height: 110%;
}
.div-survey-question > span {
  font-size: .8rem;
  color: yellow;
  white-space: nowrap;
}
.div-survey-footer {
  text-align: right;
  font-size: .8rem;
}
.btn-survey {
  color: white;
  cursor: pointer;
  font-size: 110%;
  border: 2px solid black;
  background: none;
  box-shadow: none;
  border-radius: 0px;
  background-color: #000;
  vertical-align: middle;
  text-align: left;
  padding: 20px 0 20px 15px;
  position: relative;
}
.btn-survey-unchecked {
    background-color: #303030;
}
.btn-survey-checked {
    background-color: #5f645e;
}
.btn-survey-submit {
  background-color: #0094d6;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Survey.vue